import { render, staticRenderFns } from "./TheCgCreditsBalanceBar.vue?vue&type=template&id=3fb815c3&scoped=true"
import script from "./TheCgCreditsBalanceBar.vue?vue&type=script&lang=js"
export * from "./TheCgCreditsBalanceBar.vue?vue&type=script&lang=js"
import style0 from "./TheCgCreditsBalanceBar.vue?vue&type=style&index=0&id=3fb815c3&prod&lang=scss"
import style1 from "./TheCgCreditsBalanceBar.vue?vue&type=style&index=1&id=3fb815c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb815c3",
  null
  
)

export default component.exports